import React, { Fragment, useEffect, useState } from 'react'
import Header from '../../components/header/Header'
import PageTitle2 from '../../components/pagetitle/PageTitle2'
import Footer from '../../components/footer/Footer'
import Scrollbar from '../../components/scrollbar/scrollbar'
import { API_URL } from '../../constant'

function MyWalletPage() {
  const [topCoinTotal, setTopCoinTotal] = useState(0);
  const [topCoinPoints, setTopCoinPoints] = useState(Array(12).fill(0));
  const [topCoinLoading, setTopCoinLoading] = useState(true);

  const [allocatedAmount, setAllocatedAmount] = useState(0);
  const [allocatedLoading, setAllocatedLoading] = useState(true);

  const currentMonthIndex = new Date().getMonth();

  useEffect(() => {
    const fetchTopCoins = async () => {
      try {
        const response = await fetch(`${API_URL}/api/public/wallet/chart-data`);
        if (!response.ok) {
          throw new Error('Failed to fetch chart data');
        }
        const data = await response.json();
        const points = Array.isArray(data?.monthly_points) ? data.monthly_points : [];

        // Ensure we have 12 slots; pad missing months with 0
        const normalizedPoints = Array.from({ length: 12 }, (_, idx) => Number(points[idx]) || 0);
        setTopCoinPoints(normalizedPoints);

        // Use current month only
        const currentMonthValue = Number(normalizedPoints[currentMonthIndex]) || 0;
        setTopCoinTotal(currentMonthValue);
      } catch (err) {
        console.error('Error fetching chart data:', err);
        setTopCoinPoints(Array(12).fill(0));
        setTopCoinTotal(0);
      } finally {
        setTopCoinLoading(false);
      }
    };

    fetchTopCoins();
  }, []);

  useEffect(() => {
    const fetchAllocatedDiscount = async () => {
      try {
        setAllocatedLoading(true);
        const response = await fetch(`${API_URL}/api/public/wallet/chart-data`);
        if (!response.ok) {
          throw new Error('Failed to fetch cash data');
        }

        const data = await response.json();

        let cashValues = [];
        if (Array.isArray(data?.cumulative_cash_values)) {
          cashValues = data.cumulative_cash_values;
        } else if (Array.isArray(data?.monthly_cash_values)) {
          cashValues = data.monthly_cash_values;
        } else if (Array.isArray(data?.monthly_data)) {
          cashValues = data.monthly_data.map((m) => Number(m?.cash_value) || 0);
        } else if (Array.isArray(data?.monthly_points)) {
          const rate = Number(data?.overall_stats?.conversion_rate) || 0.005;
          cashValues = data.monthly_points.map((p) => (Number(p) || 0) * rate);
        }

        const normalizedCash = Array.from({ length: 12 }, (_, idx) => Number(cashValues[idx]) || 0);

        // Use current month cash value only
        const currentMonthCash = Number(normalizedCash[currentMonthIndex]) || 0;

        setAllocatedAmount(currentMonthCash);
      } catch (err) {
        console.error('Error fetching cash data:', err);
        setAllocatedAmount(0);
      } finally {
        setAllocatedLoading(false);
      }
    };

    fetchAllocatedDiscount();
  }, []);

  return (
    <Fragment>
      <div className="index_ico page_wrapper">
        <Header />
        <main className="page_content">
          <PageTitle2 pageTitle={"My Wallet"} pagesub={"Home"} />

          <section className="wallet-page section_space pt-30 pb-5 mt-5 text-dark">
            <div className="container">
              <div className="row g-4">
                <div className="col-12">
                  <div className="wallet-card">
                    <h5 className="wallet-heading">My Wallet overview</h5>
                    <p className="wallet-text">
                      Your My Wallet area shows how TopCoin rewards, Bonus, and Cash Wallet rewards are recorded as you shop with participating retailers on the Topcoin UK platform.
                    </p>
                    <p className="wallet-text">
                      Topcoin UK operates as an advertising and loyalty platform, where participating retailers provide reward-based discounts and promotional benefits through customer activity.
                    </p>
                    <p className="wallet-text">
                      All rewards displayed are free, retailer-funded, and provided in accordance with platform rules. Values shown are indicative and for platform purposes only.
                    </p>
                    <p className="wallet-text">
                      Wallet balances may include TopCoin, Bonus and Cash Wallet rewards, each operating under their own conditions and eligibility criteria.
                    </p>
                    <p className="wallet-text mb-0">
                      Access to certain features, including withdrawals, is subject to platform rules, verification procedures, and compliance requirements.
                    </p>
                  </div>
                </div>

                <div className="col-12">
                  <div className="wallet-card h-100">                  
                    <h6 className="wallet-title">Withdrawal</h6>
                    <p className="wallet-text">
                      Customers may request withdrawal of eligible TopCoin balances at any time, subject to platform rules, verification procedures, and compliance requirements.
                    </p>
                    <ul className="wallet-list mb-0">
                      <li>Withdrawal requests are subject to identity and compliance checks</li>
                      <li>Minimum and maximum limits may apply</li>
                      <li>Processing times may vary</li>
                      <li>When TopCoin is withdrawn, any associated Bonus TopCoin will be removed</li>
                      <li>Bonus TopCoin may not be reissued after withdrawal or reset.</li>
                    </ul>
                  </div>
                </div>

                <div className="col-12">
                  <div className="wallet-card h-100">
                    <h6 className="wallet-title">Bonus Wallet</h6>
                    <p className="wallet-text">
                      Example potential value shown for illustration purposes: up to £150 depending on activity
                    </p>
                    <p className="wallet-text">
                      Bonus is a promotional reward issued by participating retailers through the Topcoin UK platform and recorded within the customer&apos;s wallet.
                    </p>
                    <ul className="wallet-list">
                      <li>Provided through retailers via the Topcoin UK platform</li>
                      <li>Issued as a promotional reward linked to customer activity</li>
                      <li>Designed to support and enhance overall platform participation</li>
                    </ul>
                    <p className="wallet-text">
                      As a customer&apos;s TopCoin activity increases, additional Bonus may be recorded within the wallet in accordance with platform rules.
                    </p>
                    <p className="wallet-text">
                      Bonus is maintained separately from TopCoin and does not reduce or affect the customer&apos;s TopCoin balance.
                    </p>
                    <p className="wallet-text">
                      All displayed values are indicative and represent platform-based reward or benefit values only.
                    </p>
                    <p className="wallet-text">
                      Bonus does not represent a stored monetary balance and is applied in accordance with platform rules and conditions.
                    </p>

                    <h6 className="wallet-subtitle">Withdrawal (Bonus Wallet)</h6>
                    <p className="wallet-text">
                      Customers may request withdrawal of their available Bonus balance at any time, subject to platform rules, verification procedures, and compliance requirements.
                    </p>
                    <ul className="wallet-list mb-0">
                      <li>Withdrawal of Bonus does not reduce or affect the customer&apos;s TopCoin balance</li>
                      <li>Withdrawal requests are subject to identity and compliance checks</li>
                      <li>Minimum and maximum limits may apply</li>
                      <li>Processing times may vary</li>
                      <li>
                        Customers are responsible for any tax obligations arising from the withdrawal or use of Bonus in accordance with applicable laws.
                      </li>
                    </ul>
                  </div>
                </div>

                {/* <div className="col-12">
                  <div className="wallet-card h-100">
                    <h6 className="wallet-title">Cash Wallet (Customer Rewards)</h6>
                    <p className="wallet-text">
                      The Cash Wallet represents platform-based rewards generated through participating retailers listed on the Topcoin UK platform.
                    </p>
                    <p className="wallet-text">
                      These rewards are made available to customers based on their overall participation and TopCoin activity within the platform.
                    </p>
                    <ul className="wallet-list">
                      <li>Rewards are generated from participating retailers through Topcoin UK</li>
                      <li>Distributed to customers in accordance with platform activity and rules</li>
                      <li>The Cash Wallet is a shared platform feature and does not represent individual ownership of funds</li>
                    </ul>
                    <p className="wallet-text">
                      As your TopCoin balance increases, your eligibility for rewards within the Cash Wallet may increase.
                    </p>

                    <h6 className="wallet-subtitle">How Rewards Work</h6>
                    <p className="wallet-text">
                      When a customer reaches the required level (starting from 20,000 TopCoins, including any applicable Bonus TopCoin), access to the Cash Wallet may become available.
                    </p>
                    <p className="wallet-text">
                      Rewards within the Cash Wallet are distributed proportionally based on a customer&apos;s TopCoin activity relative to overall platform activity at the time of allocation.
                    </p>
                    <p className="wallet-text">
                      All reward amounts are calculated and applied in accordance with Topcoin UK platform rules and may vary over time.
                    </p>

                    <h6 className="wallet-subtitle">Important Notice</h6>
                    <ul className="wallet-list">
                      <li>Access to the Cash Wallet is subject to eligibility thresholds and platform conditions</li>
                      <li>Reward amounts are not fixed and may vary depending on platform activity</li>
                      <li>The Cash Wallet does not represent a savings account, investment, or guaranteed return</li>
                      <li>All rewards are distributed at the discretion of Topcoin UK Ltd in accordance with platform rules</li>
                    </ul>

                    <h6 className="wallet-subtitle">Withdrawal</h6>
                    <p className="wallet-text">
                      Customers may request withdrawal of eligible Cash Wallet rewards, subject to platform rules, verification procedures, and compliance requirements.
                    </p>
                    <ul className="wallet-list mb-0">
                      <li>Withdrawal requests are subject to identity and compliance checks</li>
                      <li>Minimum and maximum limits may apply.</li>
                      <li>Processing times may vary</li>
                      <li>
                        Customers are responsible for any tax obligations arising from Cash Wallet withdrawals in accordance with applicable laws.
                      </li>
                    </ul>
                  </div>
                </div> */}
              </div>
            </div>
          </section>
        </main>
        <Footer />
        <Scrollbar />
      </div>

      <style>{`
        .wallet-page {
           margin-top: 48px;
           padding-top: 72px;
        }

        .wallet-page {
          color: var(--bs-dark-text-emphasis, #1f2937);
        }

        .wallet-page .wallet-card {
          background: #ffffff;
          border: 1px solid #e5e7eb;
          border-radius: 12px;
          padding: 20px;
          box-shadow: 0 6px 18px rgba(0, 0, 0, 0.05);
          color: var(--bs-dark-text-emphasis, #1f2937);
        }

        .wallet-heading {
          font-size: 20px;
          font-weight: 700;
          margin-bottom: 12px;
          color: #111;
        }

        .wallet-title {
          font-size: 18px;
          font-weight: 700;
          margin-bottom: 10px;
          color: #111;
        }

        .wallet-subtitle {
          font-size: 16px;
          font-weight: 700;
          margin: 14px 0 8px;
          color: #111;
        }

        .wallet-label {
          font-size: 16px;
          font-weight: 600;
          margin-bottom: 6px;
          color: var(--bs-dark-text-emphasis, #1f2937);
        }

        .wallet-value {
          font-size: 16px;
          font-weight: 700;
          color: var(--bs-dark-text-emphasis, #0f172a);
          margin-bottom: 10px;
        }

        .wallet-inline-value {
          font-size: 16px;
          font-weight: 700;
          color: var(--bs-dark-text-emphasis, #0f172a);
          margin-left: 8px;
          display: inline;
        }

        .wallet-text {
          font-size: 16px;
          color: var(--bs-dark-text-emphasis, #1f2937);
          margin-bottom: 8px;
          line-height: 1.5;
        }

        .wallet-list {
          padding-left: 25px;
          margin-bottom: 10px;
          color: var(--bs-dark-text-emphasis, #1f2937);
          font-size: 16px;
          line-height: 1.5;
        }

        .wallet-list li {
          margin-bottom: 4px;
        }

        .wallet-footnote {
          font-size: 16px;
          color: #4b5563;
          margin-bottom: 0;
        }

        .notice-card {
          background: #f9fafb;
          border-color: #e5e7eb;
        }

        @media (max-width: 991px) {
          .wallet-page .wallet-card {
            padding: 16px;
          }

          .g-4, .gy-4 {
            --bs-gutter-y: 0rem; 
          }

          .wallet-heading {
            font-size: 17px;
          }

          .wallet-title {
            font-size: 15px;
          }

          .wallet-subtitle {
            font-size: 14px;
          }

          .wallet-text,
          .wallet-list,
          .wallet-label,
          .wallet-value {
            font-size: 13px;
          }
        }

        @media (max-width: 575px) {
          .wallet-page .wallet-card {
            padding: 14px;
          }

          .g-4, .gy-4 {
            --bs-gutter-y: 0rem; 
          }

          .wallet-heading {
            font-size: 16px;
          }

          .wallet-title {
            font-size: 14px;
          }

          .wallet-subtitle {
            font-size: 13px;
          }

          .wallet-text,
          .wallet-list,
          .wallet-label,
          .wallet-value {
            font-size: 12.5px;
          }
        }
      `}</style>
    </Fragment>        
  )
}

export default MyWalletPage